import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

const headingStyle = (theme: Theme) => css({
  color: theme.textColors.info,
  fontSize: 15,
  textTransform: 'uppercase',
});

type OneDimensionalTableHeaderProps = Readonly<{
  value: string;
}>;

export const OneDimensionalTableHeader = ({ value, ...restProps }: OneDimensionalTableHeaderProps) => {
  const [t] = useTranslation();

  return (
    <div
      {...restProps}
      css={headingStyle}
      title={value}
      data-element="one-dimensional-table-header"
    >
      {value || t('Empty').toUpperCase()}
    </div>
  );
};
